var map = {
	"./admin_settings.png": 1675,
	"./catalog.png": 1676,
	"./catalogWhite.png": 1677,
	"./cms.png": 1678,
	"./component-fields/Asset.png": 1679,
	"./component-fields/Blocks.png": 1680,
	"./component-fields/Boolean.png": 1681,
	"./component-fields/Date-time.png": 1682,
	"./component-fields/LInk.png": 1683,
	"./component-fields/Markdown.png": 1684,
	"./component-fields/Multi asset.png": 1685,
	"./component-fields/Multi options.png": 1686,
	"./component-fields/Number.png": 1687,
	"./component-fields/Richtext.png": 1688,
	"./component-fields/Single options.png": 1689,
	"./component-fields/Table.png": 1690,
	"./component-fields/Text area.png": 1691,
	"./component-fields/Text.png": 1692,
	"./components.png": 1693,
	"./configuration.png": 1694,
	"./contents.png": 1695,
	"./custom_order.png": 1696,
	"./customer_credits.png": 1697,
	"./dashboard.png": 1698,
	"./home.png": 1699,
	"./integrations.png": 1700,
	"./layaway.png": 1701,
	"./move.png": 1702,
	"./new_sale.png": 1703,
	"./orders.png": 1704,
	"./payment-methods/amex.png": 1267,
	"./payment-methods/discover.png": 1266,
	"./payment-methods/mastercard.png": 1265,
	"./payment-methods/visa.png": 1264,
	"./payments.png": 1705,
	"./register.png": 1706,
	"./repair_center.png": 1707,
	"./reports.png": 1708,
	"./services.png": 1709,
	"./trade_in_center.png": 1710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1454;